export class DeviceUtilitiesService {
    constructor() {
        this.userAgent = window.navigator.userAgent.toLocaleLowerCase();
    }
    isPhone() {
        return (this.userAgent.match(/iphone/) != null ||
            (this.userAgent.match(/android/) && this.userAgent.match(/mobile/)));
    }
    isAndroid() {
        return this.userAgent.match(/android/) != null;
    }
    isLinuxTablet() {
        return (this.userAgent.match(/ipad/) == null &&
            this.userAgent.match(/linux/) != null &&
            window.screen.width >= 600 &&
            window.screen.width <= 2000 &&
            'ontouchstart' in window &&
            window.screen.height / window.screen.width >= 0.6);
    }
    isIOS() {
        return (this.userAgent.match(/iphone/) != null ||
            this.userAgent.match(/ipad/) != null ||
            this.userAgent.match(/ipod/) != null);
    }
    isTablet() {
        return (this.userAgent.match(/ipad/) ||
            (this.userAgent.match(/android/) && !this.userAgent.match(/mobile/)));
    }
    isMac() {
        return (this.userAgent.match(/macintosh/i) &&
            this.userAgent.match(/macintosh/i)[0] === 'macintosh');
    }
    isMobile() {
        return this.isTablet() || this.isPhone() || this.isMac();
    }
}
//# sourceMappingURL=DeviceUtilitiesService.js.map